import { environment } from '../../../../../../src/environments/environment'
import {
	Component,
	OnInit,
	ViewChild,
	Input,
	Output,
	EventEmitter
} from '@angular/core'
import { DemandDetails, DemandNear, DetailDemandNear } from 'src/app/models/Demand'
import { NotificationService } from 'src/app/services/notification.service'
import { SchedulingService } from 'src/app/services/scheduling.service'
import { AWSService } from 'src/app/services/aws.service'
import { NgForm } from '@angular/forms'
import { Problems } from 'src/app/models/Problems'
import { ViewValidation } from 'src/app/_helpers/ViewValidation'
import { getUniqueId, removeToolTip } from 'src/app/_helpers/Utils'
import { getIdentifierName, getLoggedUser } from 'src/app/_helpers/LocalStorage'
import { DemandRegion } from 'src/app/models/DemandRegion'
import { ServiceType } from 'src/app/models/ServiceType'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { iconsLabelSchedulingAppraisal, TIconsLabel } from 'src/app/_helpers/iconsBaseMaps'

@Component({
	selector: 'app-schedule',
	templateUrl: './schedule.component.html'
})
export class ScheduleComponent implements OnInit {

	constructor(
		public notificationService: NotificationService,
		private schedulingService: SchedulingService,
		private awsService: AWSService
	) { }

	@Input() public idMongo: string = ''
	@Input() public isGroupingFlow: boolean = false
	@Output() public close: EventEmitter<any> = new EventEmitter()
	@Output() public getDemands: EventEmitter<any> = new EventEmitter()
	@Output() public runSchedule: EventEmitter<any> = new EventEmitter()
	@Output() public dataDemandToGroup: EventEmitter<string> = new EventEmitter()

	@ViewChild('form') public form: NgForm

	public labelOptions: any = {
		url: 'assets/images/m1.svg',
		scaledSize: {
			width: 40,
			height: 40
		}
	}

	public ViewValidation: ViewValidation = new ViewValidation()

	public demand: DemandDetails = new DemandDetails()
	public demandsNear: Array<DemandNear> = []
	public detailsNearDemand: DetailDemandNear = null
	public nearDemandSelectToGroup: DetailDemandNear = null
	public legendsMapDemand: TIconsLabel = iconsLabelSchedulingAppraisal
	public oldDemand: string
	public problems: Array<Problems> = []
	public demandServiceTypes: Array<ServiceType> = []
	public demandRegions: Array<DemandRegion> = []
	public sessionUser: UserAdmin = getLoggedUser()

	public openDelete: boolean = false
	public isAdmin: boolean = false
	public problemsSelect: boolean = false
	public enableScheduleButton: boolean = false
	public loading: boolean = false
	public foundAddress: boolean = false
	public loadingDemandServiceTypes = false
	public loadingDemandRegions = false
	public openNewService: boolean = false
	public arrowLeftEnable: boolean = false
	public arrowRightEnable: boolean = true
	public photoFromCarouselEnable: boolean = false
	public desableSalveButton: boolean = true
	public initMarker: boolean = false
	public updateMap: boolean = false
	public screenShotCompleted: boolean = false
	public enableEditOrCreate: boolean = false
	public openModalViewChilds: boolean = false
	public imagesSelectedDemand = []

	public nameFile: string = ''
	public carouselPageNow: number = 1
	public carouselItens: number = 0
	public carouselPages: number = 0
	public mediaUrlSelected: string = ''
	public companyId: string = localStorage.getItem('companyId')
	public identifierName: string = getIdentifierName()
	public last_protocol: number = 0

	public async ngOnInit(): Promise<void> {

		this.demand.companyId = this.companyId

		this.isAdmin = Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN') || this.sessionUser.roles.includes('CUSTOMER'))

		const hasCreatePermition = Boolean(this.sessionUser.assignments.includes('APPRAISAL_SCHEDULE_CREATE'))

		this.enableEditOrCreate = Boolean(hasCreatePermition || this.isAdmin)

		await this.getDemandServiceTypes()
		await this.getDemandRegions()
		await this.getProblems()

		this.problems.forEach(problem => {
			problem.active = false
		})

		if (this.idMongo) {
			const hasUpdatePermition = Boolean(this.sessionUser.assignments.includes('APPRAISAL_SCHEDULE_UPDATE'))
			this.enableEditOrCreate = Boolean(hasUpdatePermition || this.isAdmin)

			await this.getDemandDetails()
			this.initMarker = true

			if (!this.demand.parentDemand) {
				this.getNearDemands({
					lat: this.demand.lat,
					lng: this.demand.lng
				})
			}
		}

		this.oldDemand = JSON.stringify(this.demand)

		this.enableScheduleButton = true
	}

	public takePhoto(event: { url: string}) {
		this.convertImageToBase64(event.url, (base64Image: string) => {
			this.insertImageFromMapView(base64Image)
		})
	}

	public convertImageToBase64(url: string, callback) {
		fetch(url).then(response => {
						if (!response.ok) {
				this.notificationService.notify('Erro ao buscar imagem do google maps', 500)
		  throw new Error('Network response was not ok.')
						}
						return response.blob()
				})
				.then(blob => {
						const reader = new FileReader()
						reader.readAsDataURL(blob)
						reader.onloadend = function() {
				callback(reader.result)
						}
				})
				.catch(error => {
						console.error('Fetching error:', error)
			   this.notificationService.notify('Erro ao buscar imagem do google maps', 500)
				})
	}

	private async insertImageFromMapView(base64: string): Promise<void> {
		const blob = this.base64ToBlob(base64)

		const file = new File([blob], 'image.jpg', { type: 'image/jpeg' })

		this.imagesSelectedDemand = this.imagesSelectedDemand.concat(file)

		this.demand.media.unshift(base64)

		this.carouselItens++

		this.setCarouselPages(this.carouselItens)
		this.setDesableSalveButton()

		this.screenShotCompleted = !this.screenShotCompleted
	}

	private base64ToBlob(base64: string): Blob {
		const data = base64.split(',')[1]
		const byteString = atob(data)
		const arrayBuffer = new ArrayBuffer(byteString.length)
		const int8Array = new Uint8Array(arrayBuffer)

		for (let i = 0; i < byteString.length; i++) {
			int8Array[i] = byteString.charCodeAt(i)
		}

		return new Blob([int8Array], { type: 'image/jpeg' })
	}

	public async getProblems(): Promise<void> {
		try {
			this.problems =
				await this.schedulingService.getProblems().toPromise()

			this.problems.forEach(problem => {
				problem.active = false
			})
		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}
	}

	public async getDemandServiceTypes(): Promise<void> {
		try {
			this.loadingDemandServiceTypes = true

			const demandServiceTypes =
				await this.schedulingService.getDemandServiceTypesByCompanyId(this.companyId).toPromise()

			this.demandServiceTypes = demandServiceTypes.map(serviceType => {
				return {
					id: serviceType.id,
					name: serviceType.name
				}
			})

			this.demandServiceTypes.sort((a, b) => {
				if (a.id < b.id) {
					return -1
				}
				if (a.id > b.id) {
					return 1
				}
				return 0
			})

		} catch (err) {
			this.showErrorInConsole(err)
		} finally {
			this.loadingDemandServiceTypes = false
		}
	}

	public async getDemandRegions(): Promise<void> {
		try {
			this.loadingDemandRegions = true

			const demandRegions =
				await this.schedulingService.getDemandRegionsByCompanyId(this.companyId).toPromise()

			this.demandRegions = demandRegions.map(region => {
				return {
					id: region.id,
					name: region.name
				}
			})

			this.demandRegions.sort((a, b) => {
				if (a.id < b.id) {
					return -1
				}
				if (a.id > b.id) {
					return 1
				}
				return 0
			})

		} catch (err) {
			this.showErrorInConsole(err)
		} finally {
			this.loadingDemandRegions = false
		}
	}

	public async getDemandDetails(): Promise<void> {
		this.demand =
			await this.schedulingService.getDemandDetailsForId(this.idMongo).toPromise()

		for (let index = 0; index < this.problems.length; index++) {
			for (let index2 = 0; index2 < this.demand.problems.length; index2++) {
				if (this.demand.problems[index2]._id === this.problems[index]._id) {
					this.problems[index].active = true
				}
			}
		}

		this.carouselItens = this.demand.media.length
		this.setCarouselPages(this.carouselItens)
		this.hasProblemSelected()
	}

	public closeDetails(): void {
		this.close.emit()
	}

	public async updateLocationDemand(event: { latitude: number, longitude: number, street: string }) {

		this.demand.address = event.street
		this.demand.lat = event.latitude
		this.demand.lng = event.longitude

		this.setDesableSalveButton()
	}

	public async getCoordenates(address: string): Promise<void> {

		if (!(this.enableEditOrCreate || this.isAdmin)) return

		this.loading = true
		this.initMarker = true

		try {
			const geocoder: any = new google.maps.Geocoder()

			await geocoder.geocode({ address }, (results, status) => {
				if (status === google.maps.GeocoderStatus.OK && results) {

					this.demand.address = results[0].formatted_address
					this.demand.lat = results[0].geometry.location.lat()
					this.demand.lng = results[0].geometry.location.lng()

					this.getNearDemands({
						lat: this.demand.lat,
						lng: this.demand.lng
					})
				}
			})

			this.foundAddress = true
			this.setDesableSalveButton()
			this.updateMap = !this.updateMap
		} catch (err) {
			console.log(err)

			this.demand.address = ''
			this.foundAddress = false
		}

		this.loading = false
	}

	public async deleteDemand(): Promise<void> {
		try {
			const response: any =
				await this.schedulingService.removeDemand(this.demand.idMongo).toPromise()

			this.getDemands.emit()
			this.close.emit()

			this.notificationService.notify(response.message, 200)
		} catch (err) { }
	}

	public async cancelSchedule(): Promise<void> {
		try {
			const demandId: string =
				this.demand.parentDemand ? this.demand.parentDemand.idMongo : this.demand.idMongo

			const response: any =
				await this.schedulingService.cancelAppraisal(this.demand.appraisalId, demandId).toPromise()

			this.getDemands.emit()
			this.close.emit()

			this.notificationService.notify(response.message, 200)
		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}
	}

	public openDeleteModal(): void {
		this.openDelete = true
	}

	public closeDeleteModal(): void {
		this.openDelete = false
	}

	public handleProblems(index: number): void {

		if (
			!(this.enableEditOrCreate || this.isAdmin) ||
			['PENDENTE', 'ATRASADO'].includes(this.demand.status)
		) return

		const problemSelected: Problems = this.problems[index]

		problemSelected.active = !problemSelected.active

		/**
		 * Ativa qualquer problema e desativa árvore caída
		 */
		if (!problemSelected.media_url.includes('Arvore_caida')) {
			this.problems.forEach((problem, i) => {
				if (problem.media_url.includes('Arvore_caida')) {
					problem.active = false
				}
			})
		}

		/**
		 * Ativa apenas árvore caída e desativa todos
		 */
		if (problemSelected.media_url.includes('Arvore_caida')) {
			this.problems.forEach((problem, i) => {
				if (!problem.media_url.includes('Arvore_caida')) {
					problem.active = false
				}
			})
		}

		/**
		 * Verifica se existe problema selecionado
		 */
		this.hasProblemSelected()
		this.setDesableSalveButton()
	}

	public hasProblemSelected() {
		this.problemsSelect = this.problems.some(problem =>
			problem.active === true
		)
	}

	public moveCarousel(direction: 'left' | 'right') {
		const carousel = document.getElementById('carousel-content') as HTMLDivElement
		const carouselWidth: number = 748

		if (direction == 'left') {
			if (this.carouselPageNow > 1) {
				this.carouselPageNow--
			}
		}
		if (direction == 'right') {
			if (this.carouselPageNow < this.carouselPages) {
				this.carouselPageNow++
			}
		}

		if (this.carouselPageNow > 1) {
			this.arrowLeftEnable = true
		} else {
			this.arrowLeftEnable = false
		}

		if (this.carouselPageNow == this.carouselPages) {
			this.arrowRightEnable = false
		} else {
			this.arrowRightEnable = true
		}

		const carouselPosition: number = carouselWidth * (this.carouselPageNow - 1)
		carousel.style.left = `-${carouselPosition}px`
	}

	public setCarouselPages(itens: number) {
		this.carouselPages = Math.ceil(itens / 3)
	}

	public openClosePhotoFromCarousel(media?: string) {
		if (media) {
			this.photoFromCarouselEnable = true
			this.mediaUrlSelected = media
		} else {
			this.photoFromCarouselEnable = false
			removeToolTip()
		}
	}

	private selectedImagesDemand($event): void {
		const files = $event.srcElement.files
		this.imagesSelectedDemand = this.imagesSelectedDemand.concat(...files)

		for (let i = 0; i < files.length; i++) {
			const reader = new FileReader()

			reader.readAsDataURL(files[i])

			reader.onload = () => {
				const base64Image = reader.result.toString()

				this.demand.media.unshift(base64Image)
			}
		}

		this.carouselItens++

		this.setCarouselPages(this.carouselItens)
		this.setDesableSalveButton()
	}

	private async deleteImageDemand(image): Promise<void> {

		if (['PENDENTE', 'ATRASADO'].includes(this.demand.status)) return

		const imageDelete =
			this.demand.media.filter(imageDelete => imageDelete !== image)

		this.demand.media = imageDelete

		this.carouselItens--

		this.setCarouselPages(this.carouselItens)

		if (this.carouselPages == 1) {
			const carousel = document.getElementById('carousel-content') as HTMLDivElement

			carousel.style.left = '0px'
		}

		this.setDesableSalveButton()
	}

	public setDesableSalveButton() {
		this.desableSalveButton = false
	}

	public openModalNewService() {
		this.openNewService = true
	}

	public closeModalNewService() {
		this.openNewService = false
	}

	public async updateDemandServiceTypes() {
		await this.getDemandServiceTypes()
	}

	public eraserCoordenates(): void {
		this.foundAddress = false
		this.demand.address = ''
	}

	public async saveDemand(isNew: boolean): Promise<void> {
		try {
			this.notificationService.initLoading()

			const problemsToSave: Array<Problems> =
				this.problems.filter(problem => problem.active)

			this.demand.problems = problemsToSave

			const linksImages = this.demand.media.filter( image => image.includes('https'))

			if (this.imagesSelectedDemand.length > 0) {

				for await (const images of this.imagesSelectedDemand) {
					const fileWithNewName =
						new File([images], getUniqueId() + '-' + images.name, {
							type: images.type,
							lastModified: images.lastModified
						})

					const data = await this.awsService.uploadToS3(fileWithNewName)

					linksImages.unshift(data.Location)
				}
			}

			this.demand.media = linksImages

			let response: any

			if (!isNew) {
				const demandToUpdate = {...this.demand, oldDemand: this.oldDemand}

				response =
					await this.schedulingService.patchDemand(demandToUpdate).toPromise()
				this.getDemands.emit()
				this.close.emit()
				this.notificationService.notify(response.message, 200)
			} else {
				response =
					await this.schedulingService.addDemand(this.demand).toPromise()

				if (this.isGroupingFlow) {
					this.dataDemandToGroup.emit(response.content.idMongo)
				} else {
					this.getDemands.emit()
					this.last_protocol = response.content.identification
					this.notificationService.notify(response.message, 200)
				}
			}
		} catch (err) {
			if (environment.ENV !== 'PROD') {
				console.log(err)
			}
		}
	}

	public openSteps() {
		this.notificationService.initLoading()
		this.runSchedule.emit()
	}

	private showErrorInConsole(err: Error) {
		if (environment.ENV !== 'PROD') {
			console.log(err)
		}
	}

	public async getNearDemands(data: {lat: number, lng: number}) {
		if (this.nearDemandSelectToGroup) return

		this.demandsNear =
			await this.schedulingService.getNearDemands({
				...data,
				companyId: this.companyId,
				selfDemandId: this.demand.idMongo
			}).toPromise()
	}

	public async getDetailDemand(demandId: string) {
		this.detailsNearDemand =
			await this.schedulingService.getDetailsNearDemand(demandId).toPromise()
	}

	public groupNearDemand() {
		if (!this.demand.region.id) {
			this.demand.region = this.detailsNearDemand.region
		}

		this.setCarouselPages(this.demand.media.length)

		this.demandsNear = []
		this.demand.parentDemand = {
		 	idMongo: this.detailsNearDemand.idMongo,
			protocol: this.detailsNearDemand.protocol,
			address: this.detailsNearDemand.address,
			status: this.detailsNearDemand.status
		}
		this.nearDemandSelectToGroup = this.detailsNearDemand

		this.clearDetailNearDemand()
		this.setDesableSalveButton()
	}

	public removeGroupDemand() {

		this.demand.parentDemand = null
		this.nearDemandSelectToGroup = null

		this.getNearDemands({
			lat: this.demand.lat,
			lng: this.demand.lng
		})

		this.setDesableSalveButton()
	}

	public clearDetailNearDemand() {
		this.detailsNearDemand = null
	}

	public openCloseModalViewChilds() {
		this.openModalViewChilds = !this.openModalViewChilds
	}
}
